// Textos de Admin › Eventos (catálogo de eventos y sus categorías). Se
// registran junto al resto de vocabularios en AppComponent; setTranslation los
// fusiona (también SIDEBAR y PAGE_HEADER).
export const locale = {
  lang: 'es',
  data: {
    SIDEBAR: {
      EVENTS_SECTION: 'Eventos',
      EVENTS: 'Eventos',
      EVENT_CATEGORIES: 'Categorías de eventos',
    },
    PAGE_HEADER: {
      EVENTS: 'Conciertos, partidos, festivales… a los que los usuarios crean viajes. Da de alta, edita, cancela o reactiva cada evento.',
      EVENT_CATEGORIES: 'Las categorías que se eligen al dar de alta un evento y su nombre en cada idioma.',
      EVENTS_TICKETMASTER: 'Eventos de Ticketmaster en España de los próximos días. Elige los que quieras y añádelos al catálogo de una vez.',
    },
    EVENTS: {
      LOADING: 'Cargando…',
      RETRY: 'Reintentar',
      SAVE: 'Guardar',
      SAVE_CHANGES: 'Guardar cambios',
      SAVING: 'Guardando…',
      DELETING: 'Eliminando…',
      PREVIOUS: 'Anterior',
      NEXT: 'Siguiente',
      COL_STATUS: 'Estado',
      COL_ACTIONS: 'Acciones',
      FIELD_REQUIRED: 'Este campo es obligatorio.',
      GENERIC_ERROR: 'Ha habido un error. Inténtalo de nuevo en unos minutos.',
      STATUS: {
        active: 'Activo',
        cancelled: 'Cancelado',
      },
      LEGACY: {
        concert: 'Concierto',
        sport: 'Deporte',
        festival: 'Festival',
        fair: 'Feria',
        theatre: 'Teatro',
        other: 'Otro',
      },
      SOURCE: {
        backoffice: 'Dashboard',
        ticketmaster: 'Ticketmaster',
      },
      LIST: {
        ADD: 'Nuevo evento',
        IMPORT_TICKETMASTER: 'Importar de Ticketmaster',
        IMPORT_FOOTBALL_DATA: 'Importar Primera División',
        PANEL_TITLE: 'Próximos eventos',
        PANEL_TITLE_ALL: 'Todos los eventos',
        PANEL_SUB: 'Ordenados por fecha. La hora es la del recinto. Sin «Incluir pasados», solo salen los que no han terminado.',
        SEARCH: 'Buscar por nombre o artista…',
        STATUS_ALL: 'Todos los estados',
        FILTER_CATEGORIES: 'Categorías',
        FILTER_CITY: 'Ciudad',
        FILTER_FROM: 'Desde',
        FILTER_TO: 'Hasta',
        FILTER_PAST: 'Eventos pasados',
        FILTER_INCLUDE_PAST: 'Incluir pasados',
        DATES_INVALID: 'La fecha «Hasta» no puede ser anterior a «Desde».',
        CHIP_BETWEEN: 'Del {{from}} al {{to}}',
        CHIP_FROM: 'Desde el {{from}}',
        CHIP_TO: 'Hasta el {{to}}',
        REMOVE_FILTER: 'Quitar el filtro {{label}}',
        COL_DATE: 'Fecha',
        COL_EVENT: 'Evento',
        COL_CATEGORY: 'Categoría',
        COL_PLACE: 'Lugar',
        COL_TRIPS: 'Viajes',
        EMPTY: 'No hay eventos próximos.',
        EMPTY_FILTERED: 'Ningún evento coincide con los filtros.',
        LOAD_ERROR: 'No se han podido cargar los eventos.',
        SHOWING: 'Mostrando {{shown}} de {{total}} eventos',
        PER_PAGE: '{{count}} por página',
        PER_PAGE_ARIA: 'Eventos por página',
      },
      TICKETMASTER: {
        TITLE: 'Importar de Ticketmaster',
        PANEL_TITLE: 'Eventos en Ticketmaster',
        PANEL_SUB: 'En España, de hoy al {{until}} ({{days}} días). La hora es la del recinto. Puedes elegir eventos de varias páginas.',
        PANEL_SUB_GENERIC: 'En España, de hoy a los próximos días. La hora es la del recinto.',
        SEARCH: 'Buscar por nombre, artista o recinto…',
        LOAD_ERROR: 'No se han podido cargar los eventos de Ticketmaster.',
        EMPTY: 'Ticketmaster no tiene eventos para estas fechas.',
        EMPTY_FILTERED: 'Ningún evento de Ticketmaster coincide con la búsqueda.',
        SHOWING: 'Mostrando {{shown}} de {{total}} espectáculos ({{dates}} fechas)',
        SELECT_PAGE: 'Elegir todos los de esta página',
        SELECT_ROW: 'Elegir «{{name}}»',
        SELECT_GROUP: 'Elegir todas las fechas de «{{name}}»',
        DATES: '{{count}} fechas',
        DATES_RANGE: 'Del {{from}} al {{to}}',
        SHOW_DATES: 'Ver las fechas',
        HIDE_DATES: 'Ocultar las fechas',
        GROUP_IN_CATALOG: '{{count}} en el catálogo',
        TIME_TBD: 'Hora por confirmar',
        TIME_TBD_HINT: 'Ticketmaster aún no ha dado la hora. Se guardará a las 00:00: corrígela en la ficha del evento cuando se sepa.',
        NO_VENUE: 'Sin recinto',
        IN_CATALOG: 'En el catálogo',
        IN_CATALOG_HINT: 'Ya está en el catálogo.',
        CANCELLED_HINT: 'Está cancelado en Ticketmaster.',
        MISSING: 'Ticketmaster no da todos los datos (falta: {{fields}}). Si lo necesitas, créalo a mano desde «Nuevo evento».',
        INCOMPLETE: 'Datos incompletos',
        INVALID: 'No se ha añadido',
        INVALID_HINT: 'El catálogo no lo ha aceptado. Revisa: {{fields}}.',
        EXTERNAL_ID: 'Identificador de Ticketmaster',
        OPEN_TM: 'Ver en Ticketmaster',
        SELECTION: 'Eventos elegidos',
        SELECTED: 'Eventos elegidos: {{count}}',
        NEEDS_CATEGORY: 'Elige la categoría de los marcados en rojo ({{count}}).',
        CLEAR_SELECTION: 'Quitar selección',
        IMPORT: 'Añadir al catálogo ({{count}})',
        IMPORTING: 'Añadiendo…',
        IMPORT_ERROR: 'No se han podido añadir los eventos',
        RESULT_CREATED: 'Eventos añadidos al catálogo: {{count}}',
        RESULT_NONE_NEW: 'Los eventos elegidos ya estaban en el catálogo',
        RESULT_PARTIAL: 'Se han añadido {{created}} de {{sent}} eventos al catálogo',
        RESULT_FAILED: 'No se ha añadido ningún evento al catálogo',
        RESULT_EXISTING: 'Ya estaban: {{count}}.',
        RESULT_INVALID: 'Con errores: {{count}} (marcados en la tabla).',
        GO_TO_EVENTS: 'Ver eventos',
        KEEP_IMPORTING: 'Seguir importando',
        TM_STATUS: {
          offsale: 'Sin venta',
          cancelled: 'Cancelado en Ticketmaster',
          canceled: 'Cancelado en Ticketmaster',
          postponed: 'Aplazado',
          rescheduled: 'Cambio de fecha',
        },
      },
      FOOTBALL_DATA: {
        CONFIRM_TITLE: '¿Importar los partidos de Primera?',
        CONFIRM_TEXT: 'Se traen de football-data los partidos de Primera División de los próximos días que ya tienen hora oficial. Los que ya están en el catálogo se actualizan si ha cambiado la hora.',
        CONFIRM: 'Importar partidos',
        IMPORTING: 'Importando…',
        DONE: 'Importados',
        RESULT_TITLE: 'Partidos nuevos: {{created}} · con hora nueva: {{updated}}',
        RESULT_NONE: 'No hay partidos nuevos ni cambios de hora',
        UNCHANGED: 'Ya estaban y sin cambios: {{count}}.',
        UNCONFIRMED: 'Aún sin hora oficial: {{count}}. Se traerán al volver a importar cuando la tengan.',
        CONFLICTS: 'Han cambiado de hora pero tienen viajes pendientes, así que no se han movido ({{count}}). Revísalos en su ficha:',
        CONFLICT_ITEM: '{{name}}: {{now}} → {{next}}',
        SKIPPED: 'Sin estadio conocido, no se han traído ({{count}}): {{names}}.',
        WINDOW: 'Partidos hasta el {{until}} ({{days}} días). Las horas, en hora de Madrid.',
      },
      DETAIL: {
        TITLE: 'Detalle del evento',
        NEW_TITLE: 'Nuevo evento',
        BACK: 'Volver al listado',
        CREATE: 'Crear evento',
        TRIPS: 'Viajes vinculados',
        PENDING_ROUTES: 'Trayectos por salir',
        PENDING_USERS: 'Usuarios con viajes',
        TIME_ZONE: 'Zona horaria',
        SOURCE: 'Origen',
        SEE_LINKED: 'Ver viajes vinculados',
        CANCELLED_TITLE: 'Evento cancelado',
        CANCELLED_TEXT: 'No aparece en la app ni admite viajes nuevos. Sus viajes pendientes se cancelan en segundo plano, sin penalización, y cada usuario recibe un aviso.',
        LOAD_ERROR: 'No se ha podido cargar el evento.',
        SAVE_ERROR: 'No se ha podido guardar el evento.',
        CREATED_TITLE: 'Evento creado',
        SAVED_TITLE: 'Cambios guardados',
      },
      FORM: {
        SECTION_EVENT: 'Evento',
        SECTION_PLACE: 'Lugar',
        SECTION_WHEN: 'Fecha y hora',
        NAME: 'Nombre',
        PERFORMER: 'Artista o equipos',
        PERFORMER_HINT: 'Opcional. Por ejemplo, el grupo o los equipos del partido.',
        CATEGORY: 'Categoría',
        CATEGORY_PLACEHOLDER: 'Elige una categoría',
        CATEGORY_INACTIVE: '{{name}} (desactivada)',
        PLACE_SEARCH: 'Buscar el recinto o la dirección',
        PLACE_SEARCH_PLACEHOLDER: 'Estadio, sala, recinto ferial…',
        PLACE_SEARCH_HINT: 'Al elegir un lugar se rellenan el recinto, la dirección, la ciudad y la ubicación. Puedes retocar los textos después.',
        PLACE_LOCKED: 'La ubicación no se puede cambiar: el evento tiene viajes que aún no han salido.',
        VENUE: 'Recinto',
        ADDRESS: 'Dirección',
        CITY: 'Ciudad',
        LOCATION: 'Ubicación',
        SEE_MAP: 'Ver en el mapa',
        NO_LOCATION: 'Sin ubicación: elige el lugar en el buscador.',
        LOCATION_REQUIRED: 'Elige el lugar en el buscador para fijar la ubicación.',
        START_DATE: 'Día de inicio',
        START_TIME: 'Hora de inicio',
        END_DATE: 'Día de fin',
        END_TIME: 'Hora de fin',
        START_REQUIRED: 'Indica el día y la hora de inicio.',
        END_TIME_REQUIRED: 'Indica también la hora de fin.',
        END_BEFORE_START: 'El fin no puede ser anterior al inicio.',
        TIME_ZONE: 'Zona horaria del recinto',
        TIME_ZONE_HINT: 'Las horas se guardan en esta zona. Se pone sola al elegir el lugar.',
        TZ_MADRID: 'Península, Baleares, Ceuta y Melilla (Europe/Madrid)',
        TZ_CANARY: 'Canarias (Atlantic/Canary)',
        LOCKED_TITLE: 'Tiene viajes que aún no han salido ({{routes}})',
        LOCKED_TEXT: 'No se pueden cambiar la fecha, la hora, la zona horaria ni la ubicación. Si hay que moverlo, cancélalo (se avisa a los usuarios) y crea uno nuevo.',
        CHECK_FIELDS: 'Revisa los campos marcados.',
        NO_CHANGES: 'No has cambiado nada.',
      },
      LINKED: {
        TITLE: 'Viajes vinculados',
        SUB: 'Trayectos de usuarios hacia o desde el evento que aún no han salido, uno por fila.',
        EMPTY: 'No hay viajes pendientes de salir.',
        LOAD_ERROR: 'No se han podido cargar los viajes vinculados.',
        COL_USER: 'Usuario',
        COL_ROLE: 'Rol',
        COL_LEG: 'Trayecto',
        COL_DEPARTURE: 'Salida',
        COL_MATCH: 'Match',
        MATCHED: 'Con match',
        NOT_MATCHED: 'Sin match',
        ROLE: {
          driver: 'Conductor',
          rider: 'Pasajero',
        },
        LEG: {
          outbound: 'Ida',
          return: 'Vuelta',
        },
        SUMMARY_OUTBOUND: 'Ida: {{count}}',
        SUMMARY_RETURN: 'Vuelta: {{count}}',
        SUMMARY_DRIVERS: 'Conductores: {{count}}',
        SUMMARY_RIDERS: 'Pasajeros: {{count}}',
        SUMMARY_MATCHED: 'Con match: {{count}}',
      },
      ACTIONS: {
        CANCEL: 'Cancelar evento',
        KEEP: 'No cancelar',
        CANCEL_TITLE: 'Cancelar «{{name}}»',
        CANCEL_TEXT_NO_TRIPS: 'No tiene viajes pendientes. Dejará de aparecer en la app y no admitirá viajes nuevos.',
        CANCEL_SUMMARY_ROUTES: 'Trayectos que se cancelan: <b>{{routes}}</b>',
        CANCEL_SUMMARY_USERS: 'Usuarios que reciben un aviso: <b>{{users}}</b>',
        CANCEL_SUMMARY_SPLIT: '<span class="bo-swal-muted">Ida {{outbound}} · vuelta {{back}} · conductor {{drivers}} · pasajero {{riders}}</span>',
        CANCEL_SUMMARY_NOTE: 'Se cancelan en segundo plano y sin penalización. El evento deja de aparecer en la app.',
        CANCELLING: 'Cancelando…',
        CANCELLED: 'Cancelado',
        REACTIVATE: 'Reactivar evento',
        REACTIVATE_TITLE: 'Reactivar «{{name}}»',
        REACTIVATE_TEXT: 'Volverá a aparecer en la app y admitirá viajes nuevos. Los viajes que se cancelaron no se recuperan.',
        REACTIVATED: 'Reactivado',
        DELETE: 'Eliminar evento',
        DELETE_TITLE: 'Eliminar «{{name}}»',
        DELETE_TEXT: 'Solo para eventos sin viajes, por ejemplo uno creado por error. No se puede deshacer.',
        DELETED: 'Eliminado',
        DELETE_BLOCKED_TITLE: 'No se puede eliminar el evento',
        DELETE_BLOCKED_TEXT: 'Tiene viajes. Puedes cancelarlo en su lugar.',
        ERROR_TITLE: 'No se ha podido completar la acción',
      },
      CATEGORIES: {
        ADD: 'Nueva categoría',
        TABS_ARIA: 'Estado de la categoría',
        TAB_all: 'Todas',
        TAB_active: 'Activas',
        TAB_inactive: 'Desactivadas',
        PANEL_TITLE_all: 'Todas las categorías',
        PANEL_TITLE_active: 'Categorías activas',
        PANEL_TITLE_inactive: 'Categorías desactivadas',
        PANEL_SUB: 'En el orden en que salen en la app. Las desactivadas no se pueden elegir para un evento nuevo; los que ya la tienen la conservan.',
        COL_NAME: 'Nombre',
        COL_CODE: 'Código',
        COL_LEGACY: 'Categoría general',
        COL_ORDER: 'Orden',
        COL_EVENTS: 'Eventos',
        ACTIVE: 'Activa',
        INACTIVE: 'Desactivada',
        BASE: 'Básica',
        BASE_HINT: 'Una de las 6 categorías de siempre: no se puede eliminar.',
        EMPTY: 'No hay categorías en esta vista.',
        LOAD_ERROR: 'No se han podido cargar las categorías.',
        EDIT: 'Editar categoría',
        NEW_TITLE: 'Nueva categoría',
        NEW_SUB: 'Se podrá elegir al dar de alta un evento.',
        EDIT_TITLE: 'Editar categoría',
        SECTION_NAME: 'Nombre en cada idioma',
        SECTION_CLASSIFICATION: 'Clasificación',
        NAME_ES: 'Castellano',
        NAME_EN: 'Inglés',
        NAME_CA: 'Catalán',
        CODE_HINT: 'Identificador estable: minúsculas, números y «_». Se sugiere desde el nombre en castellano y luego no se puede cambiar.',
        CODE_LOCKED: 'El código no se puede cambiar.',
        CODE_INVALID: 'Solo minúsculas sin acentos, números y «_», hasta 32 caracteres.',
        LEGACY_PLACEHOLDER: 'Elige la categoría general',
        LEGACY_HINT: 'Categoría general a la que pertenece: es la que ven las versiones antiguas de la app. Luego no se puede cambiar.',
        LEGACY_LOCKED: 'La categoría general no se puede cambiar.',
        ORDER_HINT: 'Posición en los listados (las más bajas primero).',
        ORDER_INVALID: 'Un número entero entre 0 y 100.000.',
        ACTIVE_CHECK: 'Activa',
        ACTIVE_HINT: 'Desactivada no se puede elegir para un evento nuevo.',
        CREATE: 'Crear categoría',
        CREATED_TITLE: 'Categoría creada',
        SAVED_TITLE: 'Cambios guardados',
        SAVE_ERROR: 'No se ha podido guardar la categoría.',
        ACTIVATE: 'Activar',
        ACTIVATE_TITLE: 'Activar «{{name}}»',
        ACTIVATE_TEXT: 'Se podrá volver a elegir al dar de alta un evento.',
        ACTIVATED: 'Activada',
        DEACTIVATE: 'Desactivar',
        DEACTIVATE_TITLE: 'Desactivar «{{name}}»',
        DEACTIVATE_TEXT: 'No se podrá elegir para eventos nuevos. Los eventos que ya la tienen la conservan.',
        DEACTIVATED: 'Desactivada',
        DELETE: 'Eliminar categoría',
        DELETE_TITLE: 'Eliminar «{{name}}»',
        DELETE_TEXT: 'Solo se pueden eliminar las categorías sin eventos. No se puede deshacer.',
        DELETED: 'Eliminada',
        DELETE_BLOCKED_TITLE: 'No se puede eliminar la categoría',
        DELETE_BLOCKED_BASE: 'Es una de las 6 categorías de siempre: desactívala en su lugar.',
        DELETE_BLOCKED_IN_USE: 'Tiene eventos: desactívala en su lugar.',
        ACTION_ERROR: 'No se ha podido completar la acción',
      },
    },
  },
};
